<template>
    <div class="tabs">
        <div
            class="tab"
            v-for="tab in items"
            :key="tab.value"
            :class="{ active: value === tab.value }"
            @click="$emit('input', tab.value)"
        >{{ tab.text }}</div>
    </div>
</template>

<script>
export default {
    name: 'FolderTabs',
    props: {
        items: {
            type: Array,
            required: true,
        },
        value: {
            type: [String, Number],
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../../styles/rem';
    @import '../../../../../styles/mrem';

    .tabs {
        background-color: #fff;
        height: rem(48);
        display: flex;
        user-select: none;
        cursor: pointer;
        flex-wrap: nowrap;

        @include on-mobile {
            height: mrem(48);
            overflow-x: scroll;
        }

        * {
            font-size: rem(14);
            font-weight: 600;
            line-height: rem(17);
        }

        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }

    }

    .tab {
        padding: 0 rem(24);
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: rem(2) solid #BAC5CB;
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        text-align: center;
        color: #2A2626;
        white-space: nowrap;

        @include on-mobile {
            border-bottom: mrem(2) solid #BAC5CB;
            font-size: mrem(18);
            line-height: mrem(26);
            padding: 0 mrem(24);
        }

        &.active {
            color: #4663AB;
            border-color: #4663AB;
        }
    }
</style>